import { Box, Button, Drawer } from "@mui/material";
import { cloneElement, useEffect, useState } from "react";

export default function MobileBottomDrawer({
  component = <></>,
  buttonComponent = <></>,
  reset = () => {},
  handleClose = () => {},
  isDirty = false,
  closePopUp = false,
  setClosePopUp = () => {},
  buttonCallback = () => {},
  jotopen = false
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (closePopUp) {
      reset();
      !jotopen && setOpen(false);
      setClosePopUp(false);
    }
  }, [closePopUp]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    handleClose();
    if (!isDirty && !jotopen) {
      setOpen(false);
    }
  };

  return (
    <Box textAlign="center" mt={1}>
      {/* Render the provided button with injected setOpen functionality */}
      {buttonComponent ? (
        cloneElement(buttonComponent, {
          onClick: ()=>{buttonCallback();handleOpen()},
        })
      ) : (
        <Button variant="contained" onClick={handleOpen}>
          Open Drawer
        </Button>
      )}
      <Drawer
        anchor="bottom"
        open={open}
        onClose={handleDrawerClose}
        PaperProps={{
          sx: {
            borderTopLeftRadius: "1rem",
            borderTopRightRadius: "1rem",
            borderTop: "1px solid gray",
          },
        }}
      >
        <Box
          p={3}
          textAlign="center"
          sx={{
            maxHeight: "80dvh",
          }}
        >
          {component}
        </Box>
      </Drawer>
    </Box>
  );
}